import { z } from 'zod'

type JsonData = string | number | boolean | null | { [x: string]: JsonData } | JsonData[]

export type JsonDataZodSchema = z.ZodType<JsonData>

const validateApiData = <TDataSchema extends JsonDataZodSchema>({
  data,
  schema,
}: {
  data: unknown
  schema: TDataSchema
}): z.infer<TDataSchema> => {
  try {
    return schema.parse(data)
  } catch (e) {
    const schemaErrorMessage = e instanceof Error ? `\n${e.message}` : ''
    throw new Error(`Response data did not match expected zod schema.${schemaErrorMessage}`)
  }
}

export default validateApiData
